<template>
  <div class="d-grid">
    <router-link :to="extra.url" class="btn btn-primary float-end btn-sm mb-1">{{ title }}</router-link>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra']
}
</script>
